import React, { useState } from 'react';
import { Search, Send, FileText } from 'lucide-react';
import useApi from '../../../../utils/api-manager/Helper/useApi';
const MainContent = ({
  activeTab,
  searchQuery,
  setSearchQuery,
  filteredEmails,
  selectedEmail,
  handleEmailClick,
  onEmailSent,
  loading,
  error
}) => {
  const [composeTo, setComposeTo] = useState('');
  const [composeSubject, setComposeSubject] = useState('');
  const [composeBody, setComposeBody] = useState('');
const {Post} = useApi() 


 const handleSend = async () => {
  if (!composeTo || !composeSubject || !composeBody) {
    alert("Please fill in all fields.");
    return;
  }

  const payload = {
    to: composeTo,
    subject: composeSubject,
    message: composeBody,
  };
   console.log(payload)
  try {
    const response = await Post('sendEmail', payload);
 
    console.log(response)
    if (response?.status === 200) {
      alert('Mail sent successfully!');

      const sentEmail = {
        id: Date.now(),
        sender: response.data?.sent_email?.from || "You",
        recipient: response.data?.sent_email?.to || composeTo,
        subject: response.data?.sent_email?.subject || composeSubject,
        body: response.data?.sent_email?.body || composeBody,
        date: new Date().toISOString(),
        read: true,
      };

      console.log(sentEmail);
      if (onEmailSent) {
        onEmailSent(sentEmail);
      }

      setComposeTo('');
      setComposeSubject('');
      setComposeBody('');
    } else {
      alert('Failed to send mail: ' + (response?.data?.error || 'Unknown error'));
    }
  } catch (error) {
    alert('Error sending mail: ' + error.message);
  }
};

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      backgroundColor: '#ffffff',
      position: 'relative',
      height: '100vh',
    }}>
      { }
      <div style={{
        width: '400px',
        borderRight: '1px solid #e0e0e0',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}>
        { }
        <div style={{
          padding: '20px',
          borderBottom: '1px solid #e0e0e0'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#f5f5f5',
            padding: '10px 15px',
            borderRadius: '25px',
            border: '1px solid #e0e0e0'
          }}>
            <Search size={18} style={{ color: '#666', marginRight: '10px' }} />
            <input
              type="text"
              placeholder="Search mail..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                border: 'none',
                outline: 'none',
                backgroundColor: 'transparent',
                flex: 1,
                fontSize: '14px'
              }}
            />
          </div>

          {/* {loading && (
            <div style={{ marginTop: '10px', fontSize: '13px', color: '#1976d2' }}>
              Loading emails...
            </div>
          )}
          {error && (
            <div style={{ marginTop: '10px', fontSize: '13px', color: '#f44336' }}>
              Error: {error}
            </div>
          )} */}
        </div>

        { }
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {filteredEmails.length === 0 ? (
            <div style={{
              padding: '40px 20px',
              textAlign: 'center',
              color: '#666',
              fontSize: '14px',
            }}>
              {searchQuery ? 'No emails found matching your search.' : `No emails in ${activeTab}.`}
            </div>
          ) : (
            filteredEmails.map(email => (
              <div
                key={email.id}
                onClick={() => handleEmailClick(email)}
                style={{
                  padding: '15px 20px',
                  borderBottom: '1px solid #f0f0f0',
                  cursor: 'pointer',
                  backgroundColor: selectedEmail?.id === email.id ? '#f0f8ff' : 'transparent',
                  borderLeft: selectedEmail?.id === email.id ? '3px solid #1976d2' : '3px solid transparent',
                  transition: 'all 0.2s ease',
                  position: 'relative'
                }}
                onMouseEnter={(e) => {
                  if (selectedEmail?.id !== email.id) {
                    e.currentTarget.style.backgroundColor = '#f9f9f9';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedEmail?.id !== email.id) {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }
                }}
              >
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  marginBottom: '5px'
                }}>
                  <div style={{
                    fontWeight: email.read ? 'normal' : 'bold',
                    fontSize: '14px',
                    color: '#333',
                    flex: 1
                  }}>
                    {activeTab === 'sent' ? `To: ${email.recipient}` : email.sender}
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#666',
                    marginLeft: '10px'
                  }}>
                    {/* {email.date ? new Date(email.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'No Time'} */}
                    {/* {email.time || new Date(email.date).toLocaleDateString()} */}
                    {isNaN(new Date(email.date)) ? 'Invalid Date' : new Date(email.date).toLocaleString()}

                  </div>
                </div>
                <div style={{
                  fontSize: '14px',
                  fontWeight: email.read ? 'normal' : 'bold',
                  color: email.read ? '#666' : '#333',
                  marginBottom: '5px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>
                  {email.subject}
                </div>
                <div style={{
                  fontSize: '13px',
                  color: '#888',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>
                  {email.body.replace(/<[^>]*>/g, '').substring(0, 50)}...
                </div>
                {!email.read && (
                  <div style={{
                    position: 'absolute',
                    right: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '8px',
                    height: '8px',
                    backgroundColor: '#1976d2',
                    borderRadius: '50%'
                  }} />
                )}
              </div>
            ))
          )}
        </div>

        { }
        {activeTab === 'sent' && (
          <div style={{
            padding: '20px 15px',
            borderTop: '1px solid #e0e0e0',
            backgroundColor: '#fafafa',
            boxSizing: 'border-box',
          }}>
            <input
              type="email"
              placeholder="To"
              value={composeTo}
              onChange={(e) => setComposeTo(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 15px',
                fontSize: '14px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                outline: 'none',
                marginBottom: '10px',
                boxSizing: 'border-box',
              }}
            />
            <input
              type="text"
              placeholder="Subject"
              value={composeSubject}
              onChange={(e) => setComposeSubject(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 15px',
                fontSize: '14px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                outline: 'none',
                marginBottom: '10px',
                boxSizing: 'border-box',
              }}
            />
            <textarea
              placeholder="Body"
              value={composeBody}
              onChange={(e) => setComposeBody(e.target.value)}
              rows={4}
              style={{
                width: '100%',
                padding: '10px 15px',
                fontSize: '14px',
                borderRadius: '6px',
                border: '1px solid #ccc',
                outline: 'none',
                resize: 'vertical',
                minHeight: '80px',
                marginBottom: '10px',
                boxSizing: 'border-box',
              }}
            />
            <button
              onClick={handleSend}
              style={{
                width: '100%',
                padding: '10px',
                border: 'none',
                backgroundColor: '#1976d2',
                color: 'white',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600',
                transition: 'background-color 0.2s ease',
                opacity: (!composeTo || !composeSubject || !composeBody) ? 0.5 : 1,
              }}
              disabled={!composeTo || !composeSubject || !composeBody}
              title={(!composeTo || !composeSubject || !composeBody) ? 'Fill all fields to send' : 'Send email'}
            >
              <Send size={18} style={{ verticalAlign: 'middle' }} />
              <span style={{ marginLeft: '8px' }}>Send</span>
            </button>
          </div>
        )}
      </div>

      { }
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#ffffff',
        position: 'relative',
        paddingBottom: '20px',
      }}>
        {selectedEmail ? (
          <>
            <div style={{
              padding: '30px',
              borderBottom: '1px solid #e0e0e0'
            }}>
              <h2 style={{
                margin: '0 0 15px 0',
                fontSize: '24px',
                fontWeight: '600',
                color: '#333',
                lineHeight: '1.3',

              }}>
                {selectedEmail.subject}
              </h2>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '6px',
                marginBottom: '10px',
                
              }}>
                <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
                  <strong>From:</strong> {selectedEmail.sender}
                </p>
                {selectedEmail.recipient && (
                  <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
                    <strong>To:</strong> {selectedEmail.recipient}
                  </p>
                )}
                {selectedEmail.date && !isNaN(Date.parse(selectedEmail.date)) ? (
                  <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
                    <strong>Date:</strong> {new Date(selectedEmail.date).toLocaleString()}
                  </p>
                ) : (
                  <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
                    <strong>Date:</strong> Unknown
                  </p>
                )}

              </div>
            </div>

            <div style={{
              flex: 1,
              padding: '30px',
              overflowY: 'auto'
            }}>
              <div style={{
                fontSize: '16px',
                lineHeight: '1.6',
                color: '#333',
                whiteSpace: 'pre-wrap'
              }}>
                <div dangerouslySetInnerHTML={{ __html: selectedEmail.body }} />
              </div>
            </div>
          </>
        ) : (
          <div style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            color: '#666',
            fontSize: '18px',
            
          }}>
            <FileText size={48} style={{ marginBottom: '20px', opacity: 0.3 }} />
            <div>Select an email to read</div>
            <div style={{ fontSize: '14px', marginTop: '8px', opacity: 0.7 }}>
              Choose an email from the list to view its contents
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default MainContent;